// extracted by mini-css-extract-plugin
export default {"inputIDCard":"QFaoCfQKJsKxvFZfV72h"};